
/** @type {import('tailwindcss').Config} */
export default {
  corePlugins: {
    space: false
  },
  content: [
    "./{pages,partials,layouts}/**/*.htm",
    "../../plugins/**/components/**/*.htm"
],
  theme: {
    screens: {
      sm: '640px',
      md: '768px',
      lg: '1024px',
      xl: '1280px',
    },
    fontFamily: {
      display: ['Inter', 'sans-serif'],
      body: ['Inter', 'sans-serif']
    },
    spacing: {
      '0': 0,
      '5': '0.3125rem',
      '10': '0.625rem',
      '15': '0.9375rem',
      '20': '1.25rem',
      '25': '1.5625rem',
      '30': '1.875rem',
      '40': '2.5rem',
      '50': '3.125rem',
      '60':'3.75rem',
      '70': '4.375rem',
      '80': '5rem',
      '90': '5.625rem',
      '100': '6.25rem',
      '150': '9.375rem',
      '200': '12.5rem',
      '250': '15.625rem',
      '300': '18.75rem',
      '400': '25rem',
      '500': '31.25rem',
      '900': '56.25rem',
      'auto': 'auto',
    },
    opacity: {
      '0': '0',
      '25': '.25',
      '50': '.5',
      '75': '.75',
      '10': '.1',
      '20': '.2',
      '30': '.3',
      '40': '.4',
      '50': '.5',
      '60': '.6',
      '70': '.7',
      '80': '.8',
      '90': '.9',
      '100': '1'
    },
    maxWidth: {
      '900': '56.25rem',
    },
    extend: {
      colors: {
        primary: {
          DEFAULT: '#2E1939',
          dark: '#19111E',
          light: '#653180',
        },
        secondary: {
          DEFAULT: '#00BBCE',
          dark: '#008B99'
        },
        purple: {
          '900': '#19111E',
          '800': '#2E1939',
          '300': '#9677A6'
        },
        gray: {
          '100': '#F5F2F7',
          '200': '#EBE8ED',
          '300': '#E0DCE3'
        },
        blue: {
          DEFAULT: '#1A66FF',
          '100': '#E6EEFF',
          '200': '#D1E0FF',
          '500': '#1A66FF'
        },
        red: {
          DEFAULT: '#F5393D',
          '100': '#FFDBDC',
          '200': '#FFC9CB',
          '500': '#F5393D'
        },
        orange: {
          DEFAULT: '#FF6A44'
        },
        yellow: {
          DEFAULT: '#FFBC00',
          '500': '#FFBC00',
          '800': '#C99400'
        }
      },
      zIndex: {
        '5': '5',
        '60': '60'
      }
    },
  },
  variants: {
    extend: {
      backgroundColor: ['even', 'odd'],
      borderWidth: ['last'],
    },
  },
  plugins: [],
}
